export default __webpack_public_path__ + "static/media/tv_mockup.fa4dfbc4.png";